module.exports = __webpack_public_path__ + "img/selected-market_b3e83.png";